module.exports = __webpack_public_path__ + "static/img/checking_logo.a7c0d68f.png";